module.exports = __webpack_public_path__ + "static/media/YoutubeRound.49948abf.svg";